import {ref} from 'vue'
// 仅内存状态，通知正文不落浏览器存储；与普通活动弹窗协调显示。
export const adminNoticeBlocking=ref(false)
let visit='',actor=''
const seed=()=>Array.from(crypto.getRandomValues(new Uint8Array(18)),x=>x.toString(16).padStart(2,'0')).join('')
export function adminNoticeVisit(identity:string,renew=false){if(actor!==identity || renew || !visit){actor=identity;visit=seed()}return visit}
